import React, { useState } from "react";
import "cropperjs/dist/cropper.css";
import * as $ from 'jquery'
import FileCrop from "../../../../../itrust_common/components/form/fileUploader/FileCrop";
import { useDispatch } from "react-redux";
import { change } from "redux-form";
import Alert from "../../../../../itrust_common/components/Alert";

export const MediaUpload = (props) => {
  const { label, labelClasses, imageClasses, wrapperClasses, input, uploadClasses } = props
  const [image, setImage] = useState("");
  const [allFiles, setAllFiles] = useState([]);
  var id = input.name.replace(/\[/g, '').replace(/\]/g, '').replace(/\_/g, '')
  const dispatch = useDispatch()

  const handleImageUploaded = (fileData) => {
    const { byte_size, content_type, name } = fileData;

    const maxSizes = {
      audio: 16 * 1024 * 1024, // 16 MB
      document: 100 * 1024 * 1024, // 100 MB
      image: 5 * 1024 * 1024, // 5 MB
      video: 16 * 1024 * 1024, // 16 MB
    };

    const type = content_type.split('/')[0]; // e.g., "image", "video", "audio"

    let isValid = true;
    let errorMsg = '';

    switch (type) {
      case 'image':
        if (byte_size > maxSizes.image) {
          isValid = false;
          errorMsg = `Image size exceeds 5 MB: ${name}`;
        }
        break;
      case 'video':
        if (byte_size > maxSizes.video) {
          isValid = false;
          errorMsg = `Video size exceeds 16 MB: ${name}`;
        }
        break;
      case 'audio':
        if (byte_size > maxSizes.audio) {
          isValid = false;
          errorMsg = `Audio size exceeds 16 MB: ${name}`;
        }
        break;
      case 'application':
      case 'text':
        if (byte_size > maxSizes.document) {
          isValid = false;
          errorMsg = `Document size exceeds 100 MB: ${name}`;
        }
        break;
      default:
        errorMsg = `Unsupported file type: ${content_type}`;
        isValid = false;
    }

    if (!isValid) {
      Alert.warning(errorMsg);
      setTimeout(() => dispatch(change('WhatsAppChatForm', 'whatsapp_media_attributes', null)), 200);
      return false;
    }
    return true
  };

  const onChange = (e) => {
    e.preventDefault();

    // get the files
    let files = e.target.files;

    // Process each file
    for (var i = 0; i < files.length; i++) {
      let file = files[i];

      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        let fileInfo = {
          filename: file.name,
          content_type: file.type,
          byte_size: file.size,
          file: reader.result,
          name: props.input.name.split('][').slice(-1)[0].split('_')[0]
        };
        setImage(reader.result)
        // Push it to the state
        // allFiles.push(fileInfo);
        setAllFiles([...allFiles, fileInfo])
        let validSize = handleImageUploaded(fileInfo)

        if (fileInfo.content_type.includes("image/") && validSize) {
          setAllFiles([fileInfo])
          $(`#${id}`).modal('show')
        }
        else handleSubmit(fileInfo)
      }; // reader.onload
    } // for
  };

  const handleSubmit = (file) => {
    const { onChangeHook, input } = props;
    input.onChange(file)
    if (onChangeHook)
      onChangeHook(file)
  }

  const handleRemoveMedia = () => {
    setAllFiles([])
    setImage('')
    dispatch(change('WhatsAppChatForm', 'whatsapp_media_attributes', null))
  }

  return (
    <div className={`image-upload ${wrapperClasses}`}>
      {props?.input?.value?.file && <div className="border border-light text-center text-muted position-relative">
        <span className="position-absolute whatsapp-media-remove bg-white" onClick={handleRemoveMedia}>
          <i className="las la-times-circle text-danger font-size-18 rounded-circle"></i>
        </span>
        <embed key={props.input.value.file.url || props.input.value.file} className={`${imageClasses} width-5`} src={props.input.value.file.url || props.input.value.file} style={{ objectFit: "fit" }} ></embed>
      </div>}
      <div style={{ width: "100%" }}>
        <label className={labelClasses}>
          {label && label}
          <input
            type="file"
            onChange={(e) => onChange(e)}
            {...props}
            className="d-none"
          />
          {!(props?.input?.value?.file) &&
            <div><i class="las la-paperclip font-size-30"></i></div>
          }
        </label>
        <FileCrop id={id} allFiles={allFiles} setAllFiles={setAllFiles} image={image} label={label} handleSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default MediaUpload;